import { render, staticRenderFns } from "./TeacherSignup.vue?vue&type=template&id=0358556c&scoped=true&"
import script from "./TeacherSignup.vue?vue&type=script&lang=js&"
export * from "./TeacherSignup.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSignup.vue?vue&type=style&index=0&id=0358556c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0358556c",
  null
  
)

export default component.exports